import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterUseStatusList,
	getWaterUseStatus,
	addNewWaterUseStatus,
	updateWaterUseStatus,
	deleteWaterUseStatus,
	checkWaterUseStatusExists,
} from './thunk';

export const initialState = {
	itemWaterUseStatusList: [],
	itemWaterUseStatus: null,
	isWaterUseStatusLoading: false,
	isWaterUseStatusSuccess: false,
	dataWaterUseStatus: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterUseStatusSlice = createSlice({
	name: 'WaterUseStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterUseStatusList.pending, state => {
			state.isLoadingList = true;
			state.isWaterUseStatusSuccess = false;
		});

		builder.addCase(getWaterUseStatusList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterUseStatusList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterUseStatusSuccess = true;
		});

		builder.addCase(getWaterUseStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterUseStatusSuccess = false;
		});

		builder.addCase(getWaterUseStatus.pending, state => {
			state.isWaterUseStatusLoading = true;
			state.isWaterUseStatusSuccess = false;
		});

		builder.addCase(getWaterUseStatus.fulfilled, (state, action) => {
			state.itemWaterUseStatus = action.payload;
			state.isWaterUseStatusLoading = false;
			state.isWaterUseStatusSuccess = true;
		});

		builder.addCase(getWaterUseStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterUseStatusLoading = false;
			state.isWaterUseStatusSuccess = false;
		});

		builder.addCase(addNewWaterUseStatus.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterUseStatus.fulfilled, (state, action) => {
			state.itemWaterUseStatusList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterUseStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterUseStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterUseStatus.fulfilled, (state, action) => {
			state.itemWaterUseStatusList = state.itemWaterUseStatusList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? { ...item, item: action.payload, label: action.payload.name }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterUseStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterUseStatus.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterUseStatus.fulfilled, (state, action) => {
			state.itemWaterUseStatusList = current(state.itemWaterUseStatusList)
				.filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList)
				.filter(item => item._id !== action.payload._id);
			state.statementListSelect = current(state.statementListSelect)
				.filter(item => item.value !== action.payload._id);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterUseStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterUseStatusExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterUseStatusExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterUseStatusExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterUseStatusSlice.actions;

export default WaterUseStatusSlice.reducer;
